module.exports = __webpack_public_path__ + "static/media/provedor-img2.f5fffb8a.jpg";